import React from 'react';
import "./NewsPageLoader.css";

const NewsPageLoader = () => {
    return (
        <div className="news-loader-container">
            <div className="news-loader-item-main"></div>
            <div className="news-loader-item"></div>
            <div className="news-loader-item"></div>
            <div className="news-loader-item"></div>
            <div className="news-loader-item"></div>
        </div>
    );
};

export default NewsPageLoader;
